import { useContent, useLang } from "@/context/AppContext";
import { SectionHeader, Reveal } from "@/components/ui-bits";

// Expertise — editorial "services index": numbered rows, serif titles,
// tag chips, hairline separators.
export default function Expertise() {
  const { t, L } = useLang();
  const { content } = useContent();
  const skills = content?.skills || [];

  if (!skills.length) return null;

  return (
    <section id="expertise" className="bg-obsidian py-20 lg:py-32" data-testid="expertise-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeader eyebrow={t("expertiseEyebrow")} title={t("expertiseTitle")} note={t("expertiseNote")} index={4} />

        <div className="mt-12 border-t border-hairline" data-testid="expertise-bento-grid">
          {skills.map((group, i) => (
            <Reveal key={group.id} delay={0.04}>
              <div
                data-testid={`expertise-card-${group.id}`}
                className="group grid grid-cols-1 gap-4 border-b border-hairline py-8 transition-colors duration-300 hover:bg-surface sm:grid-cols-12 sm:gap-6 sm:py-9 lg:px-6"
              >
                <div className="sm:col-span-1">
                  <span className="font-display text-2xl font-light italic text-sand/60 transition-colors duration-300 group-hover:text-vermilion">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="sm:col-span-4">
                  <h3 className="font-display text-xl font-medium tracking-tight text-bone sm:text-2xl">{L(group.title)}</h3>
                </div>
                <div className="sm:col-span-7">
                  <p className="max-w-xl text-[15px] leading-relaxed text-sand">{L(group.description)}</p>
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {(group.items || []).map((item, j) => (
                      <span
                        key={j}
                        className="border border-hairline px-2.5 py-1 font-mono text-[10.5px] font-medium text-sand transition-colors group-hover:border-vermilion/40 group-hover:text-bone"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
